/* eslint-disable no-unused-vars */
import React from 'react'
import { Link } from "react-router-dom";
import "./Login.css"
function Index() {
    return (
        <div className='login'>
            <Link to="/"><img className='loginLogo' src="/images/logologin.png" alt="" /></Link>
            <div className="Container">
                <h1>Sign In </h1>
                <form action="">
                    <h5>E-mail</h5>
                    <input type="text" />
                    <h5>Password</h5>
                    <input type="text" />
                    <button type='submit' >Sign in</button>
                </form>
                <p>By singning-in you agree to accept the terms and conditions and privacy policy</p>
                <button>Create Account</button>
            </div>
        </div>
    )
}
export default Index
